import Twemoji from "react-twemoji";
import settings from "settings";
import { useErrataIdsForPuzzle } from "stores/ScopeStateStore";
import {
  useShouldDisplayAdmin,
  useServerInteractionStore,
} from "stores/ServerInteractionStore";
import {
  useIsAdminEnabledStore,
  useAdminPreferencesStore,
} from "stores/UserPreferencesStore";
import { Link } from "components/Link";
import VolumeControl from "components/VolumeControl";
import Globals from "Globals";

function SiteNav() {
  const { hasAdminAccess } = settings;
  const shouldDisplayAdmin = useShouldDisplayAdmin();
  const errataIds = useErrataIdsForPuzzle(null, true) ?? [];

  const isAdminEnabled = useIsAdminEnabledStore(
    (state) => state.isAdminEnabled
  );
  const setIsAdminEnabled = useIsAdminEnabledStore(
    (state) => state.setIsAdminEnabled
  );
  const setIsAdminEnabledPref = useAdminPreferencesStore(
    (state) => state.setIsAdminEnabledPref
  );
  const isSpectating = useIsAdminEnabledStore((state) => state.isSpectating);
  const setIsSpectating = useIsAdminEnabledStore(
    (state) => state.setIsSpectating
  );
  const setIsSpectatingPref = useAdminPreferencesStore(
    (state) => state.setIsSpectatingPref
  );

  const sockClient = useServerInteractionStore(
    (state) => state.getSockClient
  )();

  return (
    <>
      <hr />
      <Link route="puzzles">
        <Twemoji>🌏 World</Twemoji>
      </Link>
      <Link route="teams">Teams</Link>
      {errataIds.length > 0 ? <Link route="errata">Updates</Link> : null}
      <Link route="about">About</Link>
      <a href="https://galacticpuzzlehunt.com/archive">Archive</a>
      <Link route="wrapup">Wrap-Up</Link>
      {settings.isPosthunt ? <Link route="unlock">Unlocks</Link> : null}
      <VolumeControl />
      {hasAdminAccess && sockClient !== null ? (
        <>
          <hr />
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              const newIsAdminEnabled = !isAdminEnabled;
              setIsAdminEnabled(newIsAdminEnabled);
              setIsAdminEnabledPref(newIsAdminEnabled);
              sockClient.setIsAdmin(newIsAdminEnabled);
            }}
          >
            <Twemoji tag="span">{isAdminEnabled ? "✅️" : "🔲️"}</Twemoji> Admin
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              const newIsSpectating = !isSpectating;
              setIsSpectating(newIsSpectating);
              setIsSpectatingPref(newIsSpectating);
              sockClient.isSpectating = newIsSpectating;
            }}
          >
            <Twemoji tag="span">{isSpectating ? "✅️" : "🔲️"}</Twemoji>{" "}
            Spectate
          </a>
          {shouldDisplayAdmin ? (
            <>
              <Link route="sock_admin">Sock Admin</Link>
              <Link route="health">Sock Health</Link>
              <Link route="unlock">Team Unlocks</Link>
              {/* emojify the most important ones to visually signpost */}
              <Link route="admin_queue">
                <Twemoji tag="span">🚨️</Twemoji> Admin Queue
              </Link>
              <Link route="bigboard">
                <Twemoji tag="span">🪧️</Twemoji> Big Board
              </Link>
              <a
                href="https://docs.google.com/document/d/13fTuFA3w6YXqZL2aPoAillMRmaJfZNH7PsHJ0uKbe0c"
                target="_blank"
                rel="noreferrer"
              >
                Ops Guide
              </a>
              <Link route="admin" target="_blank">
                Django Admin
              </Link>
              <Link route="bridge" target="_blank">
                Email
              </Link>
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default SiteNav;
